import { render, staticRenderFns } from "./RouteManagement.vue?vue&type=template&id=050db360&scoped=true&"
import script from "./RouteManagement.vue?vue&type=script&lang=js&"
export * from "./RouteManagement.vue?vue&type=script&lang=js&"
import style0 from "./RouteManagement.vue?vue&type=style&index=0&id=050db360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050db360",
  null
  
)

export default component.exports